import { render, staticRenderFns } from "./PurchaseWarehousing.vue?vue&type=template&id=492955cb&scoped=true&"
import script from "./PurchaseWarehousing.vue?vue&type=script&lang=js&"
export * from "./PurchaseWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseWarehousing.vue?vue&type=style&index=0&id=492955cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492955cb",
  null
  
)

export default component.exports